// Mock data for EliteBGrowth services and packages

export const services = [
  {
    id: 'website',
    name: 'Website Development',
    description: 'Custom, responsive websites tailored to your business',
    icon: 'Globe',
    price: '$700+',
    portfolioUrl: 'https://workwithebgrowth.com/website-design/#/'
  },
  {
    id: 'mobile-app',
    name: 'Mobile App Development',
    description: 'iOS and Android applications',
    icon: 'Smartphone',
    price: '$3,000+',
    portfolioUrl: 'https://workwithebgrowth.com/mobile-apps/#/'
  },
  {
    id: 'digital-marketing',
    name: 'Digital Marketing',
    description: 'SEO, PPC, and social media strategies',
    icon: 'TrendingUp',
    price: 'SEO $749/mo | PPC $400+',
    portfolioUrl: null
  },
  {
    id: 'logo',
    name: 'Logo & Branding',
    description: 'Professional brand identity design',
    icon: 'Palette',
    price: '$200+',
    portfolioUrl: 'https://workwithebgrowth.com/logo-designs/#/'
  },
  {
    id: 'animation',
    name: 'Animation / Explainer Videos',
    description: 'Engaging videos that tell your story',
    icon: 'Video',
    price: '$300/min',
    portfolioUrl: 'https://workwithebgrowth.com/video-animations/?portfolio_id=765787#/'
  },
  {
    id: 'elearning',
    name: 'eLearning Development',
    description: 'Interactive courses and training modules',
    icon: 'GraduationCap',
    price: 'Custom',
    portfolioUrl: 'https://workwithebgrowth.com/elearning-services/#/'
  },
  {
    id: 'linkedin',
    name: 'LinkedIn Services',
    description: 'Profile optimization and content strategy',
    icon: 'Linkedin',
    price: '$299/mo',
    portfolioUrl: 'https://workwithebgrowth.com/linkedin-service/#/'
  },
  {
    id: 'content-writing',
    name: 'Content Writing',
    description: 'Blog posts, website copy, scripts & social content',
    icon: 'FileText',
    price: 'From $50',
    portfolioUrl: 'https://workwithebgrowth.com/form/content-writing/#/'
  }
];

export const packages = [
  {
    id: 'starter-presence',
    name: 'Starter Presence',
    description: 'Perfect for new businesses',
    services: ['website', 'logo', 'linkedin'],
    highlights: [
      'Website (up to 5 pages)',
      'Custom logo (3 concepts)',
      'LinkedIn optimization'
    ],
    priceRange: 'From $1,200'
  },
  {
    id: 'brand-visibility',
    name: 'Brand Visibility',
    description: 'Compelling visuals & presence',
    services: ['logo', 'animation', 'website'],
    highlights: [
      'Complete brand identity',
      '60-90s explainer video',
      'Responsive website'
    ],
    priceRange: 'From $1,800'
  },
  {
    id: 'growth-marketing',
    name: 'Growth Marketing',
    description: 'Drive results with marketing',
    services: ['website', 'digital-marketing', 'linkedin'],
    highlights: [
      'Conversion website',
      'SEO + 3-month strategy',
      'LinkedIn campaigns'
    ],
    priceRange: 'From $2,500/mo'
  },
  {
    id: 'custom',
    name: 'Custom Project',
    description: 'Tell us your idea',
    services: [],
    highlights: [
      'Free consultation',
      'Custom proposal',
      'Dedicated manager'
    ],
    priceRange: "Let's discuss"
  }
];

export const portfolioLinks = {
  website: 'https://workwithebgrowth.com/website-design/#/',
  'mobile-app': 'https://workwithebgrowth.com/mobile-apps/#/',
  logo: 'https://workwithebgrowth.com/logo-designs/#/',
  animation: 'https://workwithebgrowth.com/video-animations/?portfolio_id=765787#/',
  elearning: 'https://workwithebgrowth.com/elearning-services/#/',
  linkedin: 'https://workwithebgrowth.com/linkedin-service/#/',
  'content-writing': 'https://workwithebgrowth.com/form/content-writing/#/',
  infographic: 'https://workwithebgrowth.com/infographic/#/',
  ppt: 'https://workwithebgrowth.com/power-point-presentation/#/'
};

export const pricingData = [
  { service: 'Website', price: '$700+', link: portfolioLinks.website },
  { service: 'Animation', price: '$300/min', link: portfolioLinks.animation },
  { service: 'Logo', price: '$200+', link: portfolioLinks.logo },
  { service: 'SEO', price: '$749/mo', link: null },
  { service: 'PPC', price: '$400+', link: null },
  { service: 'LinkedIn', price: '$299/mo', link: portfolioLinks.linkedin },
  { service: 'Mobile App', price: '$3,000+', link: portfolioLinks['mobile-app'] }
];

export const budgetRanges = [
  { value: 'under-1k', label: 'Under $1,000' },
  { value: '1k-3k', label: '$1,000 - $3,000' },
  { value: '3k-5k', label: '$3,000 - $5,000' },
  { value: '5k-10k', label: '$5,000 - $10,000' },
  { value: '10k-plus', label: '$10,000+' },
  { value: 'not-sure', label: 'Not sure yet' }
];

export const timelineOptions = [
  { value: 'asap', label: 'As soon as possible' },
  { value: '1-month', label: 'Within 1 month' },
  { value: '1-3-months', label: '1-3 months' },
  { value: '3-plus-months', label: '3+ months' },
  { value: 'flexible', label: 'Flexible' }
];

// Website options
export const websiteTypes = [
  { value: 'business', label: 'Business / Corporate' },
  { value: 'landing', label: 'Landing Page' },
  { value: 'ecommerce', label: 'E-commerce' },
  { value: 'portfolio', label: 'Portfolio' },
  { value: 'blog', label: 'Blog / Content' },
  { value: 'custom', label: 'Custom' },
  { value: 'other', label: 'Other' }
];

export const pageCountOptions = [
  { value: '1-3', label: '1–3 pages' },
  { value: '4-6', label: '4–6 pages' },
  { value: '7-10', label: '7–10 pages' },
  { value: '10+', label: '10+ pages' },
  { value: 'not-sure', label: 'Not sure' }
];

export const cmsOptions = [
  { value: 'wordpress', label: 'WordPress' },
  { value: 'shopify', label: 'Shopify' },
  { value: 'webflow', label: 'Webflow' },
  { value: 'framer', label: 'Framer' },
  { value: 'wix', label: 'Wix' },
  { value: 'squarespace', label: 'Squarespace' },
  { value: 'no-preference', label: 'No preference (you decide)' },
  { value: 'other', label: 'Other' }
];

export const websiteFeatures = [
  { value: 'contact-forms', label: 'Contact forms' },
  { value: 'blog', label: 'Blog' },
  { value: 'booking', label: 'Booking system' },
  { value: 'payment', label: 'Payment gateway' },
  { value: 'user-login', label: 'User login / dashboard' },
  { value: 'lms', label: 'LMS / Learning Management' },
  { value: 'forum', label: 'Forum / Community' },
  { value: 'multilingual', label: 'Multilingual' },
  { value: 'integrations', label: 'Third-party integrations' },
  { value: 'data-entry', label: 'Data entry' },
  { value: 'other', label: 'Other' }
];

// Mobile App options
export const platformOptions = [
  { value: 'ios', label: 'iOS' },
  { value: 'android', label: 'Android' },
  { value: 'both', label: 'Both' }
];

export const loginMethods = [
  { value: 'email', label: 'Email' },
  { value: 'phone-otp', label: 'Phone / OTP' },
  { value: 'social', label: 'Social login' }
];

export const paymentTypes = [
  { value: 'one-time', label: 'One-time' },
  { value: 'subscription', label: 'Subscription' },
  { value: 'in-app', label: 'In-app purchase' }
];

// Digital Marketing options
export const marketingGoals = [
  { value: 'leads', label: 'Lead generation' },
  { value: 'sales', label: 'Sales' },
  { value: 'brand', label: 'Brand awareness' },
  { value: 'traffic', label: 'Traffic growth' }
];

export const marketingServices = [
  { value: 'seo', label: 'SEO' },
  { value: 'ppc', label: 'Google Ads / PPC' },
  { value: 'social', label: 'Social Media Marketing' },
  { value: 'content', label: 'Content Marketing' },
  { value: 'email', label: 'Email Marketing' }
];

export const marketingBudgetRanges = [
  { value: 'under-500', label: 'Under $500' },
  { value: '500-1500', label: '$500–$1,500' },
  { value: '1500-3000', label: '$1,500–$3,000' },
  { value: '3000+', label: '$3,000+' },
  { value: 'not-sure', label: 'Not sure' }
];

export const socialPlatforms = [
  { value: 'instagram', label: 'Instagram' },
  { value: 'facebook', label: 'Facebook' },
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'x', label: 'X (Twitter)' }
];

// Logo & Branding options
export const logoTypes = [
  { value: 'wordmark', label: 'Wordmark' },
  { value: 'lettermark', label: 'Lettermark' },
  { value: 'abstract', label: 'Abstract' },
  { value: 'pictorial', label: 'Pictorial / Combination' },
  { value: 'emblem', label: 'Emblem' },
  { value: 'mascot', label: 'Character / Mascot' },
  { value: 'not-sure', label: 'Not sure' }
];

export const brandStyles = [
  { value: 'modern', label: 'Modern' },
  { value: 'minimal', label: 'Minimal' },
  { value: 'professional', label: 'Professional' },
  { value: 'bold', label: 'Bold' },
  { value: 'playful', label: 'Playful' },
  { value: 'luxury', label: 'Luxury' },
  { value: 'other', label: 'Other' }
];

// Animation options
export const videoTypes = [
  { value: 'explainer', label: 'Explainer' },
  { value: 'product-demo', label: 'Product demo' },
  { value: 'marketing', label: 'Marketing / Ads' },
  { value: 'training', label: 'Training / Internal' },
  { value: 'other', label: 'Other' }
];

export const videoDurations = [
  { value: '30-60', label: '30–60 seconds' },
  { value: '60-90', label: '60–90 seconds' },
  { value: '2-3min', label: '2–3 minutes' },
  { value: 'not-sure', label: 'Not sure' }
];

export const accentOptions = [
  { value: 'usa', label: 'USA' },
  { value: 'uk', label: 'UK' },
  { value: 'neutral', label: 'Neutral' }
];

export const voiceOptions = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'no-preference', label: 'No preference' }
];

// eLearning options
export const elearningTypes = [
  { value: 'corporate', label: 'Corporate training' },
  { value: 'compliance', label: 'Compliance' },
  { value: 'product', label: 'Product training' },
  { value: 'academic', label: 'Academic' },
  { value: 'coaching', label: 'Coaching / Selling' }
];

// LinkedIn options
export const linkedinProfileTypes = [
  { value: 'personal', label: 'Personal profile' },
  { value: 'business', label: 'Business page' }
];

export const linkedinServices = [
  { value: 'optimization', label: 'Profile optimization' },
  { value: 'content', label: 'Content posting' },
  { value: 'leads', label: 'Lead generation' },
  { value: 'outreach', label: 'Outreach' }
];

export const postingFrequency = [
  { value: 'weekly', label: 'Weekly' },
  { value: 'bi-weekly', label: 'Bi-weekly' },
  { value: 'monthly', label: 'Monthly' }
];

// Content Writing options
export const contentTypes = [
  { value: 'blog', label: 'Blog Post Writing ($50/500 words)' },
  { value: 'website-copy', label: 'Website Copywriting (from $200)' },
  { value: 'video-script', label: 'Video Script Writing ($100/min)' },
  { value: 'social-media', label: 'Social Media Content ($50/post)' }
];

// Project Clarity options
export const postLaunchServices = [
  { value: 'maintenance', label: 'Maintenance' },
  { value: 'content-updates', label: 'Content updates' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'analytics', label: 'Analytics / tracking' },
  { value: 'not-sure', label: 'Not sure' }
];

export const howItWorksSteps = [
  {
    step: 1,
    title: 'Choose Your Services',
    description: 'Select individual services or pick a ready-made package'
  },
  {
    step: 2,
    title: 'Answer Quick Questions',
    description: 'Our form adapts to gather exactly what we need'
  },
  {
    step: 3,
    title: 'Get Your Proposal',
    description: 'Receive clarity on scope & pricing within 24-48 hours'
  }
];
